import PersonalInformation from './PersonalInformation';

export default PersonalInformation;
